export enum PaymentType {
  CARD = "CARD",
  CASH = "CASH",
}

export enum SupportedCurrency {
  ZAR = "ZAR",
}

export enum ResultCodes {
  UNKNOWN = "UNKNOWN",
  ERROR_CANCELLED = "ERROR_CANCELLED",
  ERROR_BLUETOOTH_DISABLED = "ERROR_BLUETOOTH_DISABLED",
  ERROR_INVALID_TOKEN = "ERROR_INVALID_TOKEN",
  ERROR_NO_CONNECTIVITY = "ERROR_NO_CONNECTIVITY",
  ERROR_PERMISSION_DENIED = "ERROR_PERMISSION_DENIED",
  ERROR_PRINT_FAILED = "ERROR_PRINT_FAILED",
  ERROR_REFUND_FAILED = "ERROR_REFUND_FAILED",
  ERROR_TRANSACTION_FAILED = "ERROR_TRANSACTION_FAILED",
  ERROR_TRANSACTION_LOOKUP_FAILED = "ERROR_TRANSACTION_LOOKUP_FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  SUCCESSFUL = "SUCCESSFUL",
}
